module.exports = __webpack_public_path__ + "img/nft-bg.97b974ed.png";